import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AccountPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) { navigate("/auth"); return; }
    api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, [user, navigate]);

  const active = orders.filter((o) => !["Delivered", "Cancelled"].includes(o.status));
  const past = orders.filter((o) => ["Delivered", "Cancelled"].includes(o.status));

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-10" data-testid="account-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-gray-400 mb-2">Your account</div>
          <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter">{user?.name || user?.email}</h1>
          <p className="text-gray-500 text-sm mt-1">{user?.email}</p>
        </div>
        <button onClick={() => { logout(); navigate("/"); }} className="rounded-full border-2 border-black px-5 py-2.5 font-bold text-sm" data-testid="account-logout-btn">
          Logout
        </button>
      </div>

      {loading && <div className="mt-10 text-gray-500">Loading…</div>}

      {!loading && active.length > 0 && (
        <section className="mt-10">
          <h2 className="font-display font-bold text-xl mb-4">Active orders</h2>
          <div className="grid gap-3">
            {active.map((o) => <OrderRow key={o.id} o={o} />)}
          </div>
        </section>
      )}

      <section className="mt-10">
        <h2 className="font-display font-bold text-xl mb-4">Order history</h2>
        {past.length === 0 && !loading ? (
          <div className="rounded-2xl border border-dashed border-gray-200 p-10 text-center">
            <div className="font-display font-bold">No past orders yet</div>
            <Link to="/menu" className="inline-block mt-3 bg-black text-white rounded-full px-5 py-2 text-sm font-bold">Browse menu</Link>
          </div>
        ) : (
          <div className="grid gap-3">
            {past.map((o) => <OrderRow key={o.id} o={o} />)}
          </div>
        )}
      </section>
    </div>
  );
}

function OrderRow({ o }) {
  return (
    <Link
      to={`/track/${o.id}`}
      className="flex items-center justify-between gap-4 rounded-2xl border border-gray-100 hover:border-black bg-white p-5 transition"
      data-testid={`order-row-${o.id}`}
    >
      <div>
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-gray-400">#{o.id.slice(0, 8).toUpperCase()}</div>
        <div className="font-display font-bold text-lg mt-0.5">{o.items.length} item{o.items.length > 1 ? "s" : ""} · ₹{o.total}</div>
        <div className="text-xs text-gray-500 mt-0.5">{new Date(o.created_at).toLocaleString()}</div>
      </div>
      <div>
        <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-bold">{o.status}</span>
      </div>
    </Link>
  );
}
